import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import editorSlice from 'store/features/editor/slice'
import { ASPECT_RATIO_OPTIONS, TCanvasSizeKey } from 'consts'
import { MediaStatus } from 'types/media'
import { projectDataThunks } from 'store/features/projectData/thunks'
import {
  computeOriginalDimensions,
  normalizeDimensions
} from 'utils/originalDimensions'

export const useAspectRatioSwitch = () => {
  const { aspectRatioString, width, height } = useSelector(
    projectDataSelectors.defaultDimensions
  )
  const mediaItems = useSelector(projectDataSelectors.mediaItems)

  const hasPendingMedia = mediaItems.some(
    item => item.meta.status === MediaStatus.PENDING
  )

  const performSwitch = (key: TCanvasSizeKey) => {
    const oldCanvas = { width, height }

    let dims: { width: number; height: number } | null = null
    if (key === 'original') {
      dims = computeOriginalDimensions(mediaItems)
      dims = normalizeDimensions(dims)
      if (!dims) {
        // No media yet — fall back to widescreen so the canvas isn't broken.
        dims = ASPECT_RATIO_OPTIONS.widescreen
      }
    } else {
      dims = ASPECT_RATIO_OPTIONS[key]
    }

    dispatch(editorSlice.actions.setSelectedAspectRatioKey(key))
    dispatch(
      projectDataThunks.setDefaultDimensions({
        width: dims.width,
        height: dims.height
      })
    )
    dispatch(projectDataThunks.refitAllMediaToCanvas(oldCanvas))
  }

  const canSwitch = !hasPendingMedia

  return {
    aspectRatioString,
    hasPendingMedia,
    performSwitch,
    canSwitch
  }
}
